import React from 'react';
import logo from '../stock/ieeeday_2023_web.png';
import { getAuth, signInWithPopup, GoogleAuthProvider,setPersistence, browserLocalPersistence, signOut } from "firebase/auth";
import { useState} from 'react';
import app from "../firebase";
const headerStyle = {
  display: 'flex',
  justifyContent: 'space-around', // Align items horizontally
  alignItems: 'center', // Center items vertically
  backgroundColor: 'white',
  color: '#fff',
  padding: '10px 20px', // Adjust padding for spacing
  fontSize: '24px',
  fontWeight: 'bold',
  position: 'sticky',
  top: 0
  // position: 'fixed',
  // width: "100%",
  // zIndex: 10
};

const buttonStyle = {
  backgroundColor: '#007bff',
  color: 'white',
  border: 'none',
  borderRadius: '4px',
  padding: '10px 20px',
  cursor: 'pointer',
  fontSize: '16px',
};
const nameStyle = {
  color: '#007bff',
  backgroundColor: 'white',
  border: 'solid #007bff 2px',
  borderRadius: "4px",
  padding: '9px 19px',
  fontSize: '16px',
}

const Header = () => {
  const [flag,setFlag] = useState(localStorage.getItem('ieeextremeLoginfo'));

  const auth = getAuth();
 

  const handleLogin = ()=>{
    const provider = new GoogleAuthProvider(null);

    setPersistence(auth, browserLocalPersistence).then(()=>{
      return signInWithPopup(auth, provider)
      .then(async (result) => {
        localStorage.setItem('ieeextremeLoginfo',result.user.displayName);
        setFlag(result.user.displayName);
      });
    })
  }
  const handleLogout = ()=>{
    signOut(auth).then(() => {
      // Sign-out successful.
      localStorage.removeItem('ieeextremeLoginfo');
      setFlag(null);

    }).catch((error) => {
      // An error happened.
    });
  }
  return (
    <div style={headerStyle}>
      <a href="https://ieeedkte.web.app"><img src={logo} alt={''} /></a>
      {/* <h3 style={{color: "#007bff"}}>IEEE DKTE Student Branch</h3> */}
      {!flag && <button style={buttonStyle} onClick={handleLogin}>Log in</button>}
      {flag && <div><button style={nameStyle} >{flag}</button> <button style={buttonStyle} onClick={handleLogout}>Log Out</button></div>}
    </div>
  );
};

export default Header;
